import * as React from "react"

export default {
  title: "Install Create Next App",
}
